var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 13",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.93994 10.2002C6.94922 10.2002 7.89502 9.89551 8.68213 9.375L11.4624 12.1616C11.6465 12.3394 11.8813 12.4282 12.1353 12.4282C12.6621 12.4282 13.0493 12.0156 13.0493 11.4951C13.0493 11.2539 12.9668 11.019 12.7891 10.8413L10.0278 8.06738C10.5991 7.26123 10.9355 6.271 10.9355 5.20459C10.9355 2.45605 8.68848 0.208984 5.93994 0.208984C3.19775 0.208984 0.944336 2.45605 0.944336 5.20459C0.944336 7.95312 3.19141 10.2002 5.93994 10.2002ZM5.93994 8.86719C3.92773 8.86719 2.27734 7.2168 2.27734 5.20459C2.27734 3.19873 3.92773 1.54199 5.93994 1.54199C7.95215 1.54199 9.60254 3.19873 9.60254 5.20459C9.60254 7.2168 7.95215 8.86719 5.93994 8.86719Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.1a4c0fb0689ba16386dfd4bfb827edf5.svg";
export { ForwardRef as ReactComponent };